import { AxiosError } from "axios";
import { FieldValues, Path, useFormContext, UseFormReturn } from "react-hook-form";
import { ApiErrorResponse } from "types/models.ts";
export const useGeneralForm = <TFieldValues extends FieldValues>() => {
    const context = useFormContext<TFieldValues>() as UseFormReturn<TFieldValues>;

    const handleErrorsFromErrorResponse = (error: AxiosError<ApiErrorResponse>) => {
        const errors = error.response?.data?.exception?.errors;

        if (!errors) return;

        Object.entries(errors).forEach(([field, messages]) => {
            (messages as string[]).forEach((message) => {
                context?.setError(field as Path<TFieldValues>, {
                    type: "manual",
                    message,
                });
            });
        });
    };

    const fieldNames = Object.keys(context?.formState.defaultValues || {}).reduce(
        (acc, key) => {
            acc[key as keyof TFieldValues] = { name: key as keyof TFieldValues };
            return acc;
        },
        {} as { [K in keyof TFieldValues]: { name: K } }
    );

    const buildArrayFieldNames = <FormData>(arrayName: keyof TFieldValues, index: number) => {
        const arrayFields = context?.formState.defaultValues?.[String(arrayName)] as FormData[];

        return (Object.keys(arrayFields?.[0] || {}) as Array<keyof FormData>).reduce(
            (acc, key) => {
                acc[key] = {
                    name: `${String(arrayName)}.${index}.${String(key)}` as Path<TFieldValues>,
                };
                return acc;
            },
            {} as { [K in keyof FormData]: { name: Path<TFieldValues> } }
        );
    };

    return { handleErrorsFromErrorResponse, fieldNames, buildArrayFieldNames, ...context };
};
